import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type BundlesContainingMaterialResponse = {
    items: Material[];
    total: number;
};

type BundlesContainingMaterialApiResponse = { data: BundlesContainingMaterialResponse };

// Legacy raw-response fetcher — still consumed by src/services/bundles/bundle-service.ts
// for the cart hooks (use-find-most-recent-item-in-bundle, use-bundles-contain-cart-item).
export const getBundlesContainingMaterial = (params = {}, pathParams: { id?: number } = {}) =>
    axios.get(`${API_URLS.MATERIAL}/${pathParams.id}/bundles`, { params });

export const fetchBundlesContainingMaterial = (
    materialId: number,
    params: RequestParams = {}
): Promise<BundlesContainingMaterialResponse> =>
    (
        axios.get(`${API_URLS.MATERIAL}/${materialId}/bundles`, {
            params
        }) as unknown as Promise<BundlesContainingMaterialApiResponse>
    ).then((response) => response.data);
